@switch (kind()) {
  @case ('Role') {
    <msf-select
      [model]="roleName()"
      (modelChange)="roleNameChange.emit($event ?? '')"
      [options]="catalog.roles()"
      optionLabel="label"
      optionValue="value"
      translateBy="none"
      [placeholder]="'adminNotifications.roleName' | translate"
    ></msf-select>
  }
  @case ('Region') {
    <msf-tree-select
      [model]="entityId()"
      (modelChange)="entityIdChange.emit($event ?? '')"
      [options]="catalog.regions()"
      [placeholder]="'Select Region' | translate"
      [showClear]="true"
      appendTo="body"
    ></msf-tree-select>
  }
  @case ('Organization') {
    <msf-select
      [model]="entityId()"
      (modelChange)="entityIdChange.emit($event ?? '')"
      [service]="catalog.firms"
      serviceMethod="dictionariesFirmGetByQueryPost"
      optionLabel="names"
      optionValue="id"
      translateBy="names"
      [placeholder]="'adminNotifications.kindOrganization' | translate"
    ></msf-select>
  }
  @case ('Farm') {
    <msf-select-paginated
      [model]="entityId()"
      (modelChange)="entityIdChange.emit($event ?? '')"
      [service]="catalog.fields"
      serviceMethod="cropMonitoringFieldGetByQueryPost"
      optionLabel="name"
      optionValue="id"
      searchBy="name"
      translateBy="none"
      [placeholder]="'adminNotifications.kindFarm' | translate"
    ></msf-select-paginated>
  }
  @default {
    <msf-select
      [model]="entityId()"
      (modelChange)="entityIdChange.emit($event ?? '')"
      [options]="catalog.users()"
      optionLabel="label"
      optionValue="value"
      translateBy="none"
      [placeholder]="'adminNotifications.kindUser' | translate"
    ></msf-select>
  }
}
